import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadLinkedCompany, leadLinkedCompaniesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_LINKED_COMPANIES_MODULE = 'leadLinkedCompanies';

const dataObjectModule = getDataObjectsModule<ILeadLinkedCompany>(leadLinkedCompaniesManager, 1);
const searchModule = getSearchModule<ILeadLinkedCompany>(leadLinkedCompaniesManager);

const leadLinkedCompaniesModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_LINKED_COMPANIES_MODULE, leadLinkedCompaniesModuleInstance);

export { LEAD_LINKED_COMPANIES_MODULE };
